import { render } from "./general.vue?vue&type=template&id=302b6152&ts=true"
import script from "./general.vue?vue&type=script&lang=ts"
export * from "./general.vue?vue&type=script&lang=ts"

import "./general.vue?vue&type=style&index=0&id=302b6152&lang=scss"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__